import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../../../../__legacy__/models/error.model';
import { IMainApiService } from '../../../../../../../__legacy__/services/api.service';
import { IApiService } from '../../../../../../../__legacy__/services/api.service.base';

export interface IEditMarkingToolApiService {
  editMarkingToolAsync: (request: EditMarkingToolRequest) => Promise<void>;
}

export namespace IEditMarkingToolApiService {
  export const $: interfaces.ServiceIdentifier<IEditMarkingToolApiService> = Symbol('EDIT_MARKING_TOOL_API_SERVICE');
}

export class EditMarkingToolRequest {
  id: string;
  name: string;
  color: string;
  selectorType: string;

  constructor(name: string, id: string, color: string, selectorType: string) {
    this.id = id;
    this.name = name;
    this.color = color;
    this.selectorType = selectorType;
  }
}

@injectable()
export class EditMarkingToolApiServiceImpl implements IEditMarkingToolApiService {
  constructor(@inject(IMainApiService.$) readonly apiService: IApiService) {}

  editMarkingToolAsync = async (request: EditMarkingToolRequest): Promise<void> => {
    const result = await this.apiService.postAsync('/AnnotationTypes/Update', request);

    if (result instanceof ACDLError) {
      throw result;
    }
  };
}
